module.exports = __webpack_public_path__ + "img/service.b74a79aa.png";